const internalSiteStock = (state = [], action) => {
    switch(action.type) {
        case 'internalSiteStock':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteStock;